import './ImagePanel.css';

export default function ImagePanel({ imageUrl }) {
  return (
    <div className="image-panel">
      <div className="panel-label">
        <span>SPECIMEN</span>
        <span className="panel-label__sub">SRC · USER-SUBMITTED</span>
      </div>
      <div className="image-frame">
        <div className="image-frame__crosshair image-frame__crosshair--tl" />
        <div className="image-frame__crosshair image-frame__crosshair--tr" />
        <div className="image-frame__crosshair image-frame__crosshair--bl" />
        <div className="image-frame__crosshair image-frame__crosshair--br" />
        {imageUrl ? (
          <img src={imageUrl} alt="Analyzed specimen" className="image-frame__img" />
        ) : (
          <div className="image-frame__placeholder">NO IMAGE LOADED</div>
        )}
        <div className="image-frame__overlay">
          <span>SUBMITTED URL</span>
          <span className="image-frame__overlay-url" title={imageUrl}>
            {truncate(imageUrl, 32)}
          </span>
        </div>
      </div>
    </div>
  );
}

function truncate(s, n) {
  if (!s) return '——';
  if (s.length <= n) return s;
  return s.slice(0, n - 1) + '…';
}
